import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';

function Gallery() {
    const [isOpen, setIsOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const images = [
        '/manojkumarsingh.jpeg',
        '/bpscbihar.jpeg',
        '/manojkr.jpeg',
        '/manojsingh.jpeg',
        '/maksinghnautan.jpeg',
        '/manojkrsingh.jpeg',
        '/yuvamorchasiwan.jpeg',
        '/manojsinghmairwa.jpeg',
        '/mksinghsiwan.jpeg',
        '/mksinghnautan.jpeg',
        '/yuvamorchasiwannautan.jpeg',
        '/rashtriyayuvamorchasiwan.jpeg',
        '/rashtriyayuvamorchadelhi.jpeg',
        '/yuvamorchadelhi.jpeg',

    ];

    const openLightbox = (index) => {
        setCurrentImageIndex(index);
        setIsOpen(true);
    };

    const closeLightbox = () => setIsOpen(false);

    const goToPrevious = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    const goToNext = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    return (
        <div className="app-container">
            <Header />

            <main className="main-content">
                <section className="section">
                    <h2>Gallery</h2>
                    <div className="gallery">
                        {images.map((src, index) => (
                            <img
                                key={index}
                                src={src}
                                alt={`Sample ${index + 1}`}
                                onClick={() => openLightbox(index)}
                            />
                        ))}
                    </div>
                </section>
            </main>

            {isOpen && (
                <div className="lightbox">
                    <button className="close-btn" onClick={closeLightbox}>X</button>
                    <button className="prev-btn" onClick={goToPrevious}>←</button>
                    <img src={images[currentImageIndex]} alt="Selected" className="lightbox-img" />
                    <button className="next-btn" onClick={goToNext}>→</button>
                </div>
            )}

            <Footer />
        </div>
    );
}

export default Gallery;
